import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import AddIcon from "@mui/icons-material/Add";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import type { SvgIconComponent } from "@mui/icons-material";

export const IconEnum: Record<string, SvgIconComponent> = {
  FormatListBulletedIcon,
  FavoriteBorderIcon,
  AddIcon,
  LayersOutlinedIcon,
  AssignmentTurnedInOutlinedIcon,
  PeopleOutlineIcon,
};

